export var DefaultCfg = {
    crm: {
        BOT_KEY: '9ef80190-9fb8-436b-8050-47df7659265f',
        ALARM_CHAT_ID: 'wrkSFfCgAA99LWQJB3_7uywwL3ji-E9g|wrkSFfCgAAwI3Ls0Iuju-uGNb7JlBXeA',
        AEGIS_KEY: 'htdfvvxjZgVPhSbhXE',
        DUTY_RTX: ['andyyzzhang', 'fredhaochen'],
        SENTRY_DSN: 'https://bfbd1cbf8f3f40018a74753a7d8ace54@report.url.cn/sentry/1052',
        RESPONSE_RTX: ['fredhaochen']
    },
    prm: {
        BOT_KEY: '9ef80190-9fb8-436b-8050-47df7659265f',
        ALARM_CHAT_ID: 'wrkSFfCgAA99LWQJB3_7uywwL3ji-E9g|wrkSFfCgAAwI3Ls0Iuju-uGNb7JlBXeA',
        AEGIS_KEY: 'htdfvvxjBepRbyVYnC',
        DUTY_RTX: ['v_longlshi', 'ruikangmao'],
        SENTRY_DSN: 'https://bfbd1cbf8f3f40018a74753a7d8ace54@report.url.cn/sentry/1052',
        RESPONSE_RTX: ['ruikangmao']
    },
    'prm-weapp': {
        BOT_KEY: '9ef80190-9fb8-436b-8050-47df7659265f',
        ALARM_CHAT_ID: 'wrkSFfCgAA99LWQJB3_7uywwL3ji-E9g|wrkSFfCgAA3ywfgGsDU0KjWcu9JBX1VQ|wrkSFfCgAAkJguC5If6BqFtd5PDvmR6A',
        AEGIS_KEY: 'LlYdRfjn0XVXOqQpwV',
        DUTY_RTX: ['v_longlshi', 'ruikangmao'],
        SENTRY_DSN: 'https://bfbd1cbf8f3f40018a74753a7d8ace54@report.url.cn/sentry/1052',
        RESPONSE_RTX: ['ruikangmao']
    },
    cem: {
        BOT_KEY: '47945573-9c77-411c-94e1-800a1688dcf1',
        ALARM_CHAT_ID: 'wrkSFfCgAAkTncaD5THtItawd-TC1MQw',
        AEGIS_KEY: '',
        DUTY_RTX: ['simonyma'],
        SENTRY_DSN: 'https://bfbd1cbf8f3f40018a74753a7d8ace54@report.url.cn/sentry/1052',
        RESPONSE_RTX: ['tommyttian', 'simonyma']
    },
    tcc: {
        BOT_KEY: '47945573-9c77-411c-94e1-800a1688dcf1',
        ALARM_CHAT_ID: 'wrkSFfCgAAkTncaD5THtItawd-TC1MQw',
        AEGIS_KEY: '',
        DUTY_RTX: ['simonyma'],
        SENTRY_DSN: 'https://bfbd1cbf8f3f40018a74753a7d8ace54@report.url.cn/sentry/1052',
        RESPONSE_RTX: ['tommyttian', 'simonyma']
    },
    xiaoshouyi: {
        BOT_KEY: '9ef80190-9fb8-436b-8050-47df7659265f',
        ALARM_CHAT_ID: 'wrkSFfCgAA99LWQJB3_7uywwL3ji-E9g|wrkSFfCgAAwI3Ls0Iuju-uGNb7JlBXeA',
        AEGIS_KEY: 'vqYyVC4qDQ8vdZ14mO',
        DUTY_RTX: ['p_daoqunli'],
        SENTRY_DSN: 'https://bfbd1cbf8f3f40018a74753a7d8ace54@report.url.cn/sentry/1052',
        RESPONSE_RTX: ['p_daoqunli', 'fredhaochen']
    },
};
